import CloudflareCaptcha from "./components/CloudflareCaptcha";
import ReCAPTCHA from "react-google-recaptcha";

import { type TurnstileProps } from "react-turnstile";
import { useContent } from "contexts/contentContext/contentContext.js";

// import "./Recaptcha.scss";

type CaptchaProviderT = "google" | "cloudflare";

// Conditional interface based on the provider
type CaptchaPropsT<T extends CaptchaProviderT> = T extends "google"
  ? ReCAPTCHA
  : TurnstileProps;

interface CommonCaptchaProps extends ReCAPTCHA {
  recaptchaRef: React.RefObject<ReCAPTCHA>;
  provider?: CaptchaProviderT;
  onSuccess: (token: string) => void;
}

type RecaptchaI<T extends CaptchaProviderT> = Partial<CommonCaptchaProps> &
  Partial<CaptchaPropsT<T>>;

const Recaptcha = <T extends CaptchaProviderT>(props: RecaptchaI<T>) => {
  const { recaptchaRef, provider = "google", onSuccess, ...rest } = props;

  const { getBasicSettingsData, getLanguageCulture } = useContent();

  const globalCaptchaType = (getBasicSettingsData()?.recaptchaType ||
    provider) as CaptchaProviderT;

  const siteKey =
    globalCaptchaType === "google"
      ? getBasicSettingsData()?.recaptchaKeyReact
      : getBasicSettingsData()?.turnstileKey;

  return siteKey ? (
    globalCaptchaType === "google" ? (
      <ReCAPTCHA
        hl={getLanguageCulture()}
        ref={recaptchaRef}
        sitekey={siteKey}
        size="invisible"
        onChange={onSuccess}
        {...rest}
      />
    ) : getBasicSettingsData()?.turnstileKey ? (
      <CloudflareCaptcha
        sitekey={siteKey}
        language={getLanguageCulture()}
        ref={recaptchaRef}
        appearance="execute"
        size="invisible"
        action={(rest as unknown as TurnstileProps)?.action}
        onSuccess={onSuccess}
      />
    ) : null
  ) : null;
};
export default Recaptcha;
